import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearFormAction } from 'Redux/forms/formsActions';
import { upsertBillingAddress } from 'Redux/addresses/CMSAddressesThunks';
import { LOADING } from 'Redux/userInterface/userInterfaceConstants';
import { H2, FlexPanel, Button } from 'Common';
import { t } from 'Utils/localization/i18next';
import { showToast } from 'Utils/toastUtils';
import { isEditModeEnabled } from 'Utils/url/urlUtils';
import pencil from '@ingka/ssr-icon/paths/pencil';
import DynamicFormContainerModal from '../../_form_extended/DynamicForm/DynamicFormContainerModal';
import styles from './ShippingBillingAdresses.module.scss';

class PrimaryAddressSectionReadContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: isEditModeEnabled(window.location.search, 'billing-address')
    };
    this.myRef = React.createRef();
  }

  onEdit = () => {
    this.setState({ isEditing: true });
  };

  onClose = () => {
    this.setState({ isEditing: false }, () => {
      this.props.clearFormAction(this.props.editForm);
      this.scrollToCenter();
    });
  };

  onSubmit = async data => {
    const success = await this.props.upsertBillingAddress(
      data,
      this.props.editForm
    );
    if (success) {
      this.setState({ isEditing: false });
      showToast(
        t('dashboard.confirmation.addressPrimarySectionUpdateTitle'),
        t('dashboard.confirmation.addressPrimarySectionUpdateText')
      );
    }
    this.scrollToCenter();
  };

  scrollToCenter = () => {
    if (this.myRef) {
      this.myRef.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  setRef = node => {
    if (node) {
      this.myRef = node;
    }
  };

  render() {
    return (
      <React.Fragment>
        <div ref={this.setRef} className={styles['section-read']}>
          <FlexPanel spread className={styles['section-read-title']}>
            <H2 tagName="h2" headingSize="m" margin={false}>
              {t('dashboard.addresses.billing-address.title')}
            </H2>
            {this.props.editForm && (
              <>
                <Button
                  className={styles['edit-link']}
                  size="small"
                  type="tertiary"
                  id={`${this.props.editForm}-link`}
                  onClick={this.onEdit}
                  ssrIcon={pencil}
                >
                  {t('dashboard.account.edit.billingAddress')}
                </Button>
                <Button
                  id={`${this.props.editForm}-link-mobile`}
                  className={styles['edit-link-mobile']}
                  onClick={this.onEdit}
                  size="small"
                  type="tertiary"
                  iconOnly
                  ssrIcon={pencil}
                  aria-label={t('dashboard.account.edit.billingAddress')}
                ></Button>
              </>
            )}
          </FlexPanel>
          {this.state.isEditing && (
            <DynamicFormContainerModal
              formId={this.props.editForm}
              prefillValues={this.props.profile}
              loadingSubmit={this.props.isLoading}
              textSubmit={t('common.save')}
              textCancel={t('common.cancel')}
              onCancel={this.onClose}
              onSubmit={this.onSubmit}
              title={this.props.title}
            />
          )}
          {this.props.children}
        </div>
      </React.Fragment>
    );
  }
}

PrimaryAddressSectionReadContainer.propTypes = {
  editForm: PropTypes.string,
  profile: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  // From Redux/Thunks
  upsertBillingAddress: PropTypes.func.isRequired,
  clearFormAction: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  title: PropTypes.string
};

const mapStateToProps = state => {
  return {
    profile: state.profile,
    isLoading: state.userInterface.loading[LOADING.PRIMARY_ADDRESS_UPDATE]
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      upsertBillingAddress,
      clearFormAction
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrimaryAddressSectionReadContainer);
